import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { RiShieldKeyholeLine } from "react-icons/ri";
import useTheme from "../../utils/useTheme";
import styles from "./Dashboard.module.scss";

const DashboardLogin = () => {
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { adminLogin } = useTheme();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitting(true);
    const expected =
      process.env.REACT_APP_ADMIN_DASHBOARD_PASSWORD || "Navdurga@Admin2025";
    setTimeout(() => {
      if (password === expected) {
        adminLogin();
        toast.success("Welcome, Admin!");
        navigate("/dashboard");
      } else {
        toast.error("Incorrect admin password");
      }
      setSubmitting(false);
    }, 350);
  };

  return (
    <div className={styles.loginScreen}>
      <div className={styles.loginCard}>
        <div className={styles.loginIcon}>
          <RiShieldKeyholeLine />
        </div>
        <h2>Admin Dashboard</h2>
        <p>Enter the special admin password to manage the samiti's site.</p>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="Admin password"
            value={password}
            autoFocus
            onChange={(e) => setPassword(e.target.value)}
          />
          <button type="submit" disabled={submitting}>
            {submitting ? "Verifying..." : "Enter Dashboard"}
          </button>
        </form>
        <span className={styles.backLink} onClick={() => navigate("/")}>
          ← Back to site
        </span>
      </div>
    </div>
  );
};

export default DashboardLogin;
